import React from 'react';
import { socialLinks } from '../data';

const SocialLinks = ({ className = '' }) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {socialLinks.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 bg-white/10 hover:bg-primary rounded-full flex items-center justify-center text-white hover:text-white transition-all duration-300 hover:scale-110"
          aria-label={`Visit our ${link.icon.split(' ')[1].replace('uil-', '')} page`}
        >
          <i className={`${link.icon} text-lg`}></i>
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;